import api from '@/api';

const initialState = {
    /*
        Статический список версий смещений (запрашивается только один раз).
        * Но в планах динамическое создание таких версий.
    */
    data: null,
    /*
        Из списка версий смещений может быть выбрана только одна версия.
        В этом поле сохраняется ID такой выбранной версии.
    */
    activeOffsetVersionId: null,
    isLoading: false,
    error: null,
};

export const offsetVersionsModel = {
    name: 'offsetVersions',
    state: initialState,
    reducers: {
        setResponseData(state, payload) {
            return { ...state, data: payload, isLoading: false };
        },
        startRequest(state) {
            return { ...state, isLoading: true, error: null };
        },
        setError(state, error) {
            return { ...state, isLoading: false, error, data: null };
        },
        setOffsetVersionId(state, versionId) {
            return { ...state, activeOffsetVersionId: versionId };
        },
    },
    effects: {
        async getOffsetVersions(_, rootState) {
            const { data } = rootState.offsetVersions;
            /*
                Так как данные ПОКА никак не обновляются, не делаем повторный запрос за списком версий.
            */
            if (data) return;

            this.startRequest();

            try {
                const result = await api.carottage.fetchOffsetVersions();
                this.setResponseData(result.offsetsVersions);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log('error::fetch offset versions', error);
                this.setError(error);
            }
        },
    },
};
